import React from 'react';
import MobileUpdateForm from '../../integrations/mobile/MobileUpdateForm';

const UpdatePromotionFormContainer = () => {
  return (
    <div>
      <MobileUpdateForm />
    </div>
  );
};

export default UpdatePromotionFormContainer;
